/**
 * Pluralize a word based on count
 * @param {number} count - The number to check
 * @param {string} singular - The singular form of the word
 * @param {string} [plural] - Optional custom plural form (defaults to singular + 's')
 * @returns {string} The pluralized word
 */
export const pluralize = (count, singular, plural = null) => {
  if (count === 1) {
    return singular;
  }
  return plural || `${singular}s`;
};

/**
 * Pluralize with count prefix
 * @param {number} count - The number to display
 * @param {string} singular - The singular form of the word
 * @param {string} [plural] - Optional custom plural form
 * @returns {string} The count followed by the pluralized word
 */
export const pluralizeWithCount = (count, singular, plural = null) => {
  return `${count} ${pluralize(count, singular, plural)}`;
};
